// Hero section

import Container from "../../../components/ui/Container";
import Button from "../../../components/ui/Button";

export default function HeroSection() {
  return (
    <section className="event-noise relative min-h-screen overflow-hidden bg-event-gradient pt-24 text-white">
      <div className="absolute left-1/2 top-28 h-72 w-72 -translate-x-1/2 rounded-full bg-amber-flame-500/10 blur-3xl" />
      <div className="absolute bottom-10 right-10 h-80 w-80 rounded-full bg-burnt-tangerine-500/10 blur-3xl" />

      <Container className="relative z-10 flex min-h-[calc(100vh-6rem)] items-center justify-center py-20">
        <div className="mx-auto max-w-5xl text-center">
          <p className="mb-5 text-xs font-semibold uppercase tracking-[0.65em] text-amber-flame-500">
            ULFA 2026
          </p>

          <h1 className="font-display text-5xl font-bold leading-[0.95] tracking-tight md:text-7xl lg:text-8xl">
            The Inaugural
            <br />
            Ceremony for{" "}
            <span className="italic text-burnt-tangerine-500">
              Newly
            </span>
            <br />
            <span className="italic text-burnt-tangerine-500">
              Elected Officials
            </span>
          </h1>

          <div className="mx-auto mt-8 flex w-fit items-center gap-3">
            <span className="h-px w-10 bg-white/30" />
            <span className="h-2 w-2 rounded-full bg-amber-flame-500" />
            <span className="h-px w-10 bg-white/30" />
          </div>

          <p className="mx-auto mt-8 max-w-2xl text-sm leading-7 text-slate-300 md:text-base">
            A ceremonial gathering marking a new chapter of leadership,
            service, unity, and institutional progress.
          </p>

          <div className="mt-8 grid gap-3 text-sm text-slate-300 md:grid-cols-3">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-amber-flame-500">
                Date
              </p>
              <p className="mt-2 font-semibold text-white">Friday, May 8, 2026</p>
            </div>

            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-amber-flame-500">
                Time
              </p>
              <p className="mt-2 font-semibold text-white">9:00 AM</p>
            </div>

            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-amber-flame-500">
                Venue
              </p>
              <p className="mt-2 font-semibold text-white">
                UL Auditorium, Capitol Hill Campus
              </p>
            </div>
          </div>

          {/* <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              href="#register"
              className="w-full rounded-none bg-amber-flame-500 px-8 py-4 text-center text-xs font-bold uppercase tracking-[0.25em] text-twilight-indigo-950 transition hover:bg-amber-flame-400 sm:w-auto"
            >
              Reserve Your Seat
            </a>

            <a
              href="#program"
              className="w-full border border-white/20 px-8 py-4 text-center text-xs font-bold uppercase tracking-[0.25em] text-white transition hover:border-amber-flame-500 hover:text-amber-flame-400 sm:w-auto"
            >
              View Program
            </a>
          </div> */}

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button href="#officials" variant="primary" className="w-full sm:w-auto">
              Meet Our Leaders
            </Button>

            <Button href="#program" variant="secondary" className="w-full sm:w-auto">
              View Program
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}